<h2 mat-dialog-title>
  @let connectorCount = accessGroup?.connectorCount ?? 0;
  <mat-icon class="icon-24" svgIcon="security"></mat-icon>
  Rediger adgangsbegrænsning for
  @if (accessGroup) {
    {{ accessGroup.name }}
  }
  @if (connectorCount === 1) {
    ({{ connectorCount }} ladepunkt)
  } @else if (connectorCount > 1) {
    ({{ connectorCount }} ladepunkter)
  }
</h2>
@if (accessGroupAccessFormGroup) {
  <form [formGroup]="accessGroupAccessFormGroup" (ngSubmit)="saveAccessGroupAccess()">
    <button type="button" class="btn-close btn-icon" mat-dialog-close>
      <mat-icon class="material-icons">close</mat-icon>
    </button>
    <mat-dialog-content>
      @if (loading()) {
        <ok-dialog-loading />
      }
      <mat-tab-group [dynamicHeight]="true" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Kundenumre ({{ accessGroupAccessFormGroup.controls.customerNumbers.length }})">
          <adm-access-group-customer-number-management
            [accessGroupIdentifier]="data.accessGroupIdentifier"
            [saving]="loading()"
            (customerNumbersChanged)="handleCustomerNumbersChanged($event)" />
        </mat-tab>
        <mat-tab label="Brugere ({{ accessGroup?.chargingUserIdentifiers?.length ?? 0 }})">
          <h2 class="form-headline">Brugere</h2>
          <div class="form-row">
            @if (accessGroup) {
              <adm-drag-drop-relation
                [dragDropType]="dragDropTypeEnum.AccessGroupUser"
                [leftSideHeader]="'Brugere i ' + organizationName()"
                [rightSideHeader]="'Adgangsbegrænsning for \'' + accessGroup.name + '\' (' + selectedChargingUsers.length + ')'"
                [element]="accessGroup"
                [leftSideList]="chargingUsers"
                [rightSideList]="selectedChargingUsers"
                [title]="''"
                (dropEvent)="onChargingUserDrop($event)"
                (update)="onChargingUserUpdate($event)"
                (loadMore)="onChargingUserLoadMore()"
                (searchEvent)="onChargingUserSearch($event)" />
            }
          </div>
        </mat-tab>
        <mat-tab label="Flådebrikker ({{ accessGroup?.idTagIds?.length ?? 0 }})">
          <ng-template>
            <span
              matTooltip="Adgangsgruppen skal have biltype 'Firmabil' for at kunne tilknytte brikker"
              [matTooltipDisabled]="accessGroup?.carType === accessGroupCarTypeEnum.CompanyCar">
              Flådebrikker ({{ accessGroupIdTags.length }})
            </span>
            @if (accessGroup?.carType !== accessGroupCarTypeEnum.CompanyCar) {
              <mat-icon class="outlined med-text margin--left-s orange"> info </mat-icon>
            }
          </ng-template>
          @if (accessGroup?.carType === accessGroupCarTypeEnum.CompanyCar) {
            <h2 class="form-headline">Flådebrikker</h2>
            <ok-feedback-info>
              <div>
                <strong>Bemærk!</strong>
                <br />
                Det er kun flådebrikker, der kan tilknyttes til adgangsgruppen.
              </div>
            </ok-feedback-info>
            @if (accessGroup) {
              <adm-drag-drop-relation
                [dragDropType]="dragDropTypeEnum.AccessGroupIdTag"
                [leftSideHeader]="'Brikker i ' + organizationName()"
                [rightSideHeader]="'Adgangsbegrænsning for \'' + accessGroup.name + '\' (' + selectedIdTags.length + ')'"
                [element]="accessGroup"
                [leftSideList]="idTags"
                [rightSideList]="selectedIdTags"
                [title]="''"
                (dropEvent)="onIdTagDrop($event)"
                (update)="onIdTagUpdate($event)"
                (loadMore)="onIdTagLoadMore()"
                (searchEvent)="onIdTagSearch($event)" />
            }
          }
          @if (accessGroup?.carType !== accessGroupCarTypeEnum.CompanyCar) {
            <ok-feedback-info>
              <div>
                <strong>Bemærk!</strong>
                <br />
                Adgangsgruppen skal have biltype 'Firmabil' for at kunne tilknytte brikker
              </div>
            </ok-feedback-info>
          }
        </mat-tab>
        <mat-tab label="Adgangsoverblik ">
          <h2 class="form-headline margin--bottom-m">Hvem har adgang?</h2>
          <div class="access-list">
            <div class="access-list__item">
              <div class="access-list__item-header">Kundenumre</div>
              <div class="access-list__item-list">
                <ul>
                  @for (customerNumber of accessGroup?.customerNumbers; track customerNumber) {
                    <li>
                      {{ customerNumber }}
                    </li>
                  }
                </ul>
              </div>
            </div>
            <div class="access-list__item">
              <div class="access-list__item-header">Brugere</div>
              <div class="access-list__item-list">
                <ul>
                  @for (accessGroupChargingUser of accessGroupChargingUsers; track accessGroupChargingUser.identifier) {
                    <li>
                      {{ accessGroupChargingUser.name }}
                    </li>
                  }
                </ul>
              </div>
            </div>
            <div class="access-list__item">
              <div class="access-list__item-header">Brikker</div>
              <div class="access-list__item-list">
                <ul>
                  @for (accessGroupIdTag of accessGroupIdTags; track accessGroupIdTag.id) {
                    <li>
                      {{ accessGroupIdTag.description }}
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions>
      @if (accessGroup?.name) {
        <div class="unit-identifier">
          <div class="info-group">
            <span>Adgangsgruppe:</span>
            {{ accessGroup.name }}
          </div>
          <div class="info-group">
            <span>Biltype:</span>
            {{ accessGroup.carType | translateAccessGroupCarTypeEnum }}
          </div>
        </div>
      }
      <button class="actions__button margin--right-2" (click)="close()" type="button" mat-button [disabled]="loading()">Annuller</button>
      <button
        class="actions__button margin--right-2"
        type="submit"
        mat-raised-button
        color="primary"
        [disabled]="loading() || accessGroupAccessFormGroup.invalid || !accessGroupAccessFormGroup.dirty">
        Gem
      </button>
    </mat-dialog-actions>
  </form>
}
